
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'Filtrar Periódico',
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'date-range',
        field: 'periodo',
        label: 'Período',
        mask:'date',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_empresa',
        option: {
            key: 'id',
            label: 'nome',
            value: 'id'
        },
        label: 'Empresa',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_fdt',
        option: {
            key: 'id',
            label: 'fdt',
            value: 'id'
        },
        multiple:true,
        label: 'Frente de Trabalho',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_funcionario',
        option: {
            key: 'id',
            label: 'funcionario',
            value: 'id'
        },
        label: 'Funcionário',
        multiple:true,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'boolean',
        field: 'periodico_data_adm',
        label: 'Calcular periódico somente de funcionários sem consulta cadastrado',
        rules: ['']
    },
];



// WEBPACK FOOTER //
// ./src/components/apps/web/periodico/_form/periodico-pesquisar.js